<template>
  <div id="source_permission_set">
    <!-- 左边树结构 -->
    <div class="left_tree_box" :class="{ 'hidden_content': hiddenLeftTree }">
      <div class="move_box" @click="hiddenLeftTree = !hiddenLeftTree">
        <svg-icon icon-class="collapse-border" class="move_collapse"></svg-icon>
        <svg-icon icon-class="collapse-border-active" class="move_collapse_active"></svg-icon>
      </div>
      <el-radio-group
        v-if="!hiddenLeftTree"
        v-model="listType"
        size="small"
        style="margin-left: 10px; width: 206px"
      >
        <el-radio-button label="role">角色列表</el-radio-button>
        <el-radio-button label="user">用户列表</el-radio-button>
      </el-radio-group>
      <div style="margin-top: 8px; padding: 0 20px 0 20px">
        <el-input
          v-model="leftSearchText"
          class="self-filter-input"
          placeholder="搜索"
          clearable
          @keyup.enter.native="leftFilterTree"
        >
          <i slot="suffix" style="padding-right: 8px" @click="leftFilterTree">
            <svg-icon icon-class="input_search"></svg-icon>
          </i>
        </el-input>
      </div>

      <span class="vertical-bar fnM" :style="{ marginLeft: '16px' }">授权对象</span>
      <el-tree
        ref="leftTree"
        style="margin-top: 16px; overflow-y: auto; height: calc(100% - 138px)"
        class="self-tree data_tree"
        node-key="id"
        :props="leftDefaultProps"
        :data="leftTreeData"
        :highlight-current="true"
        :filter-node-method="filterNode"
        :default-expanded-keys="leftDefaultShowNodes"
        :expand-on-click-node="false"
        @node-click="leftHandleNodeClick"
        @node-expand="leftHandleNodeExpand"
        @node-collapse="leftHandleNodeCollapse"
      >
        <span
          slot-scope="{ node }"
          :title="node.label"
          class="self-custom-tree"
          style="line-height: 32px"
        >
          <span style="padding-right: 10px">
            <span v-html="leftHandleFilter(node.label)"></span>
          </span>
        </span>
      </el-tree>
    </div>
    <!-- 中间树结构 -->
    <div class="tree_content">
      <div class="left_tree_box center_tree_box">
        <div style="padding: 0 20px 0 20px">
          <el-input
            v-model="centerSearchText"
            class="self-filter-input"
            placeholder="搜索"
            clearable
            @keyup.enter.native="filterTree"
          >
            <i slot="suffix" style="padding-right: 8px" @click="filterTree">
              <svg-icon icon-class="input_search"></svg-icon>
            </i>
          </el-input>
        </div>
        <div style="overflow: hidden">
          <span class="vertical-bar fnM" :style="{ marginLeft: '16px', float: 'left' }">
            菜单权限
          </span>
          <el-checkbox v-model="isLinkage" style="float: right; margin-right: 16px">
            子父节点联动
          </el-checkbox>
        </div>

        <el-tree
          ref="centerTree"
          style="margin-top: 16px; overflow-y: auto; height: calc(100% - 98px)"
          class="self-tree data_tree"
          node-key="id"
          :props="defaultProps"
          :data="centerTreeData"
          :highlight-current="true"
          :filter-node-method="filterNode"
          :default-expanded-keys="defaultShowNodes"
          :expand-on-click-node="false"
          @node-click="handleNodeClick"
          @node-expand="handleNodeExpand"
          @node-collapse="handleNodeCollapse"
        >
          <span
            slot-scope="{ node }"
            :title="node.label"
            class="self-custom-tree"
            style="line-height: 32px"
          >
            <span style="padding-right: 10px">
              <span v-html="handleFilter(node.label)"></span>
            </span>
            <i
              v-if="!node.data.ac"
              style="padding-right: 12px"
              @click.prevent="() => openLock(node)"
            >
              <svg-icon class="before_icon" icon-class="grey_locked"></svg-icon>
            </i>
            <i v-if="node.data.ac" style="padding-right: 8px" @click.prevent="() => openLock(node)">
              <svg-icon
                class="before_icon"
                style="width: 18px"
                icon-class="green_unlocked"
              ></svg-icon>
            </i>
          </span>
        </el-tree>
      </div>

      <!-- 右边内容 -->
      <div class="right_content">
        <div class="search_box">
          <span class="vertical-bar fn18 fnM" style="line-height: 32px">字段权限</span>
          <el-button
            size="small"
            class="float-right"
            type="primary"
            style="width: 80px"
            @click="saveField"
          >
            保存
          </el-button>
          <el-button
            plain
            size="small"
            class="float-right plain_button"
            style="margin-right: 8px; width: 80px"
            @click="reset"
          >
            重置
          </el-button>
          <el-input
            v-model="tableSearch"
            size="small"
            placeholder="请输入关键字"
            style="width: 303px"
            class="float-right"
            clearable
            @clear="reset"
            @keyup.enter.native="reset"
          >
            <i slot="suffix" style="padding-right: 8px" @click="reset">
              <svg-icon icon-class="input_search"></svg-icon>
            </i>
          </el-input>
        </div>
        <div class="small_table" style="height: calc(100% - 0px)">
          <customTable height="100%" :table-data="tableData" order order-fixed :show-pagination="false">
            <el-table-column prop="sname" fixed label="资源名称" width="90" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ $t(scope.row.resourceElementLabel) }}
              </template>
            </el-table-column>
            <el-table-column label="自定义名称" prop="resourceElementExtendLabel" width="90" show-overflow-tooltip />
            <el-table-column prop="resourceElementCode" label="资源标识" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ scope.row.resourceElementCode }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="resourceElementType" label="类型" width="90">
              <template slot-scope="scope">
                {{ $t(`common.${TypeObject[scope.row.resourceElementType]}`) }}
              </template>
            </el-table-column>
            <el-table-column width="85">
              <template slot="header" slot-scope="scope">
                <el-checkbox
                  v-model="notShow"
                  :indeterminate="
                    tableData.some((item) => item.notShow)
                      && !notShow
                      && !tableData.some((item) => item.required)
                  "
                  :disabled="tableData.some((item) => item.required)"
                  @change="
                    (val) => {
                      checkAll(val, 'notShow');
                    }
                  "
                ></el-checkbox>
                &nbsp;不可见
              </template>
              <template slot-scope="scope">
                <el-checkbox
                  v-model="scope.row.notShow"
                  :disabled="scope.row.required"
                  @change="
                    (val) => {
                      changeCheck(val, scope.$index, 'notShow');
                    }
                  "
                ></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column width="85">
              <template slot="header" slot-scope="scope">
                <el-checkbox
                  v-model="onlyRead"
                  :indeterminate="
                    tableData.some((item) => item.onlyRead)
                      && !onlyRead
                      && !tableData.some((item) => item.required)
                  "
                  :disabled="tableData.some((item) => item.required)"
                  @change="
                    (val) => {
                      checkAll(val, 'onlyRead');
                    }
                  "
                ></el-checkbox>
                &nbsp;只读
              </template>
              <template slot-scope="scope">
                <el-checkbox
                  v-model="scope.row.onlyRead"
                  :disabled="scope.row.required"
                  @change="
                    (val) => {
                      changeCheck(val, scope.$index, 'onlyRead');
                    }
                  "
                ></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column width="85">
              <template slot="header">
                <el-checkbox
                  v-model="readyAction"
                  :indeterminate="tableData.some((item) => item.readyAction) && !readyAction"
                  @change="
                    (val) => {
                      checkAll(val, 'readyAction');
                    }
                  "
                ></el-checkbox>
                &nbsp;可操作
              </template>
              <template slot-scope="scope">
                <el-checkbox
                  v-model="scope.row.readyAction"
                  @change="
                    (val) => {
                      changeCheck(val, scope.$index, 'readyAction');
                    }
                  "
                ></el-checkbox>
              </template>
            </el-table-column>
          </customTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import data_api from "@/api/data-permission/dataPermission";
import { mapGetters } from "vuex";
import { commonFilterNode } from "@/utils";
import { Message } from "element-ui";

export default {
  name: "ResourcePermissionSet",
  props: {},
  data() {
    return {
      listType: "role",
      leftSearchText: "",
      leftFilterText: "",
      centerSearchText: "",
      centerFilterText: "",
      hiddenLeftTree: false,
      leftDefaultProps: {
        children: "children",
        label: "roleName"
      },
      defaultProps: {
        children: "children",
        label: "resourceName"
      },
      leftTreeData: [],
      centerTreeData: [{ resourceName: "根节点", children: null, id: -2, ac: false }],
      leftCurrentNode: "",
      centerCurrentNode: "",
      leftDefaultShowNodes: [],
      defaultShowNodes: [-2],
      tableData: [],
      tableSearch: "",
      TypeObject: {
        1: "column",
        2: "button",
        3: "tab",
        4: "input",
        5: "select",
        6: "dataPicker",
        7: "timepicker",
        8: "switch",
        9: "checkbox",
        10: "radio",
        11: "textarea"
      },
      notShow: false,
      onlyRead: false,
      readyAction: false,
      isLinkage: false,
      isLockAction: false
    };
  },
  watch: {
    tableData(arr) {
      if (arr.length > 0) {
        this.notShow = arr.every(item => item.notShow);
        this.onlyRead = arr.every(item => item.onlyRead);
        this.readyAction = arr.every(item => item.readyAction);
      }
    },
    listType(str) {
      this.leftCurrentNode = "";
      this.getFirstTreeList();
    }
  },
  computed: {
    ...mapGetters(["tenantId"])
  },
  created() {
    const that = this;
    window.onresize = function() {
      if (document.body.clientWidth < 1400) {
        that.hiddenLeftTree = true;
      }
    };
    this.getFirstTreeList();
    // this.getCenterTreeList();
  },
  methods: {
    // 获取最左边树结构
    async getFirstTreeList() {
      if (this.listType === "role") {
        data_api.getRoleList({}).then(res => {
          console.log("getRoleList", res);
          this.leftDefaultProps.label = "roleName";
          this.leftTreeData = res.data;
          this.$nextTick(() => {
            if (!this.leftCurrentNode) {
              this.leftCurrentNode = this.leftTreeData[0];
              this.leftDefaultShowNodes.push(this.leftTreeData[0].id);
            }

            this.$refs.leftTree && this.$refs.leftTree.setCurrentKey(this.leftCurrentNode.id);
            this.getAuthorResourceTree();
            if (this.centerCurrentNode) {
              this.getFieldList();
            }
          });
        });
      } else {
        let { data: orgList } = await data_api.getOrganization({ parseToTree: true, withUser: true }, this.tenantId);
        const { data: userList } = await data_api.getUsersTree({});
        if (userList && userList.length > 0) {
          orgList = this.handleUserData([orgList], userList);
        } else {
          orgList = [orgList];
        }
        this.leftDefaultProps.label = "orgName";
        this.leftTreeData = orgList;
        this.$nextTick(() => {
          if (!this.leftCurrentNode) {
            this.leftCurrentNode = this.leftTreeData[0];
            this.leftDefaultShowNodes.push(this.leftTreeData[0].id);
          }

          this.$refs.leftTree && this.$refs.leftTree.setCurrentKey(this.leftCurrentNode.id);
          this.getAuthorResourceTree();

          /*
           * if (this.centerCurrentNode) {
           *   this.getFieldList();
           * }
           */
        });
      }
    },
    handleUserData(data, userList) {
      for (let g = 0; g < data.length; g++) {
        if (data[g] && data[g].userIds) {
          for (let i = 0; i < data[g].userIds.length; i++) {
            for (let j = 0; j < userList.length; j++) {
              if (data[g].userIds[i] === userList[j].id) {
                const userInfo = {
                  id: data[g].userIds[i],
                  orgId: data[g].userIds[i],
                  orgName: userList[j].displayName
                };
                if (data[g].children) {
                  data[g].children.unshift(userInfo);
                } else {
                  data[g].children = [];
                  data[g].children.push(userInfo);
                }
                break;
              }
            }
          }
        }
        if (data[g].children && data[g].children.length) {
          data[g].children = this.handleUserData(data[g].children, userList);
        }
      }
      return data;
    },
    // 获取带权限资源树
    getAuthorResourceTree() {
      const targetType = this.listType === "role" ? 2 : this.leftCurrentNode.orgType ? 1 : 3;
      return data_api.getAuthorResourceTree(targetType, this.leftCurrentNode.id).then(res => {
        console.log("getAuthorResourceTree", res);
        this.centerTreeData[0].children = res.data;
        this.$nextTick(() => {
          if (!this.centerCurrentNode) {
            this.centerCurrentNode = res.data[0];
            this.defaultShowNodes.push(res.data[0].id);
          }

          this.$refs.centerTree && this.$refs.centerTree.setCurrentKey(this.centerCurrentNode.id);
          this.centerCurrentNode = this.$refs.centerTree.getCurrentNode();
          // console.log("getCurrentNode", this.$refs.centerTree.getCurrentNode());
          if (this.leftCurrentNode) {
            // this.getFieldList();
          }
        });
      });
    },
    // 解锁
    openLock(node) {
      let keys = [];
      // this.tableData = [];
      this.isLockAction = true;
      function getIds(obj) {
        if (obj.id !== -2) {
          keys.push(obj.id);
        }
        if (obj.children && obj.children.length !== 0) {
          obj.children.forEach(item => {
            getIds(item);
          });
        }
      }
      if (!this.isLinkage) {
        if (node.data.id === -2) {
          this.centerTreeData[0].ac = !node.data.ac;
          return;
        }
        keys = [node.data.id];
      } else {
        getIds(node.data);
      }
      const targetType = this.listType === "role" ? 2 : this.leftCurrentNode.orgType ? 1 : 3;
      data_api
        .unlockTree({
          keys,
          operation: "ADD",
          ac: !node.data.ac,
          // ac: true,
          targetType,
          targetId: this.leftCurrentNode.id
        })
        .then(res => {
          if (node.data.id === -2) {
            this.centerTreeData[0].ac = !node.data.ac;
          } else {
            // this.centerCurrentNode.ac = !node.data.ac;
          }
          // this.centerCurrentNode.ac = !node.data.ac;
          this.getFieldList({ ac: !node.data.ac });
          this.getAuthorResourceTree();
          this.isLockAction = false;
        });
    },

    /*
     *  获取中间树资源
     * getCenterTreeList() {
     *   data_api.getResourceTree().then((res) => {
     *     this.centerTreeData = res.data;
     *     this.$nextTick(() => {
     *       if (!this.centerCurrentNode) {
     *         this.centerCurrentNode = this.centerTreeData[0];
     *         this.defaultShowNodes.push(this.centerTreeData[0].id);
     *       }
     */

    /*
     *       this.$refs.centerTree && this.$refs.centerTree.setCurrentKey(this.centerCurrentNode.id);
     *       if (this.leftCurrentNode) {
     *         this.getFieldList();
     *       }
     *     });
     *   });
     * },
     * 重置
     */
    reset() {
      if (this.centerCurrentNode.ac) {
        this.getFieldList();
      }
    },
    // 获取字段权限列表
    getFieldList(ob) {
      console.log(this.leftCurrentNode, this.centerCurrentNode);
      const targetType = this.listType === "role" ? 2 : this.leftCurrentNode.orgType ? 1 : 3;
      const params = {
        resourceId: this.centerCurrentNode.id,
        targetId: this.leftCurrentNode.id,
        targetType,
        search: this.tableSearch
      };
      if (ob && !ob.ac) {
        return;
      }
      data_api.getFieldList(params).then(res => {
        this.tableData = res.data.map(item => {
          item = {
            ...item,
            notShow: false,
            onlyRead: false,
            readyAction: false,
            targetId: this.leftCurrentNode.id,
            id: item.resourceElementId,
            targetType,
            required: item.required
          };
          if (item.permission === 1) {
            item.notShow = true;
          }
          if (item.permission === 2) {
            item.onlyRead = true;
          }
          if (item.permission === 3) {
            item.readyAction = true;
          }
          return item;
        });
        this.$set(this.tableData);
      });
    },
    // 手动高亮筛选文本
    leftHandleFilter(str) {
      if (!this.leftFilterText || !str) { return str; }
      const index = str.indexOf(this.leftFilterText);
      const beforeStr = str.substr(0, index);
      const afterStr = str.substr(index + this.leftFilterText?.length);
      if (index > -1) {
        return `${beforeStr}<span style="color:#00B259;">${this.leftFilterText}</span>${afterStr}`;
      } else {
        return str;
      }
    },
    handleFilter(str) {
      if (!this.centerFilterText || !str) { return str; }
      const index = str.indexOf(this.centerFilterText);
      const beforeStr = str.substr(0, index);
      const afterStr = str.substr(index + this.centerFilterText?.length);
      if (index > -1) {
        return `${beforeStr}<span style="color:#00B259;">${this.centerFilterText}</span>${afterStr}`;
      } else {
        return str;
      }
    },
    // 筛选树
    leftFilterTree() {
      this.leftFilterText = this.leftSearchText;
      this.$refs.leftTree.filter(this.leftSearchText);
    },
    filterTree() {
      this.centerFilterText = this.centerSearchText;
      this.$refs.centerTree.filter(this.centerSearchText);
    },
    // 节点筛选
    filterNode(value, data, node) {
      return commonFilterNode(value, data, node);
    },
    // 树节点展开
    leftHandleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false;
      this.leftDefaultShowNodes.some(item => {
        if (item === data.id) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true;
          return true;
        }
      });
      if (!flag) {
        // 不存在则存到数组里
        this.leftDefaultShowNodes.push(data.id);
      }
    },
    leftHandleNodeCollapse(data) {
      this.leftDefaultShowNodes.some((item, i) => {
        if (item === data.id) {
          // 删除关闭节点
          this.leftDefaultShowNodes.length = i;
        }
      });
    },
    handleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false;
      this.defaultShowNodes.some(item => {
        if (item === data.id) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true;
          return true;
        }
      });
      if (!flag) {
        // 不存在则存到数组里
        this.defaultShowNodes.push(data.id);
      }
    },
    handleNodeCollapse(data) {
      this.defaultShowNodes.some((item, i) => {
        if (item === data.id) {
          // 删除关闭节点
          this.defaultShowNodes.length = i;
        }
      });
    },
    // 节点点击
    leftHandleNodeClick(node) {
      if (node.orgType && ["DEPARTMENT", "ORGANIZATION"].includes(node.orgType)) {
        Message.error("不能选择部门节点！");
        return;
      }
      this.leftCurrentNode = node;
      // 加载中间树节点
      this.getAuthorResourceTree().then(() => {
        this.$nextTick(() => {
          // 模拟点击中间树节点
          this.handleNodeClick(this.centerCurrentNode);
        });
      });
    },
    handleNodeClick(node) {
      this.centerCurrentNode = node;
      this.tableData = [];
      if (node.ac && !this.isLockAction) {
        this.getFieldList();
      }

      /*
       * this.getResourceDetail();
       * this.getDetailList();
       */
    },
    // 保存修改
    saveField() {
      this.tableData = this.tableData.map(item => {
        item.permission = 3;
        if (item.notShow) {
          item.permission = 1;
        }
        if (item.onlyRead) {
          item.permission = 2;
        }
        if (item.readyAction) {
          item.permission = 3;
        }
        return item;
      });
      data_api.saveFieldList(this.tableData).then(res => {
        Message.success("保存成功");
      });
    },
    checkAll(val, key) {
      const obj = { notShow: false, onlyRead: false, readyAction: false };
      this.tableData = this.tableData.map(item => ({ ...item, ...obj, [key]: val }));
    },
    changeCheck(val, index, key) {
      const obj = { notShow: false, onlyRead: false, readyAction: false };
      this.tableData[index] = {
        ...this.tableData[index],
        ...obj,
        [key]: val
      };
      this.tableData[index][key] = val;
      this.tableData = [...this.tableData];
    }
  }
};
</script>

<style scoped lang="scss">
#source_permission_set {
  width: 100%;
  height: 100%;
  display: flex;
  .left_tree_box {
    flex: 0 224px;
    width: 224px;
    margin-left: 0;
    transition: all 0.25s linear;
    background-color: #f9f9fb;
    padding: 10px 0 0 0;
    position: relative;
    border-right: 1px solid #dcdfe6;
    .data_tree {
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      .el-icon-more {
        transform: rotate(90deg);
      }
    }
    .data_tree::-webkit-scrollbar {
      width: 0 !important;
    }
  }

  .move_box {
    position: absolute;
    right: -34px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 50px;
    z-index: 99;
    cursor: pointer;
    .move_collapse {
      display: block;
    }

    .move_collapse_active {
      display: none;
    }

    &:hover {
      .move_collapse {
        display: none;
      }
      .move_collapse_active {
        display: block;
      }
    }
  }
  .hidden_content {
    margin-left: -224px;
    flex: inherit;
  }

  .fade-left-enter-active,
  .fade-left-leave-active {
    transition: all 0.2s ease-in;
    flex: 0 224px;
  }

  .fade-left-enter-from,
  .fade-left-leave-to {
    flex: 0 0;
  }
  .tree_content {
    display: flex;
    flex: 1;
    transition: all 0.2s ease-in;
    min-width: calc(100% - 224px);
    .center_tree_box {
      border-right: 1px solid #dcdfe6;
      position: relative;
      flex: 0 244px;
      width: 244px;
      background-color: #fff;
    }
    .right_content {
      flex: 1;
      padding: 24px;
      height: 100%;
      width: calc(100% - 224px);
      transition: all 0.6s ease-in;
      .search_box {
        margin-bottom: 16px;
        overflow: hidden;
      }
    }
  }

  .plain_button {
    color: #505363;
    background-color: #fff;
    border-color: #9da5b2;
  }
  .plain_button:hover {
    color: #00b259;
    border-color: #00b259;
  }
  .plain_button:focus {
    color: #00b259;
  }
}
</style>

<style lang="scss">
#source_permission_set {
  .self-filter-input {
    margin-bottom: 20px;
    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
    .el-input__icon {
      color: #9da5b2;
      line-height: 32px;
    }
  }
  .el-radio-button {
    .el-radio-button__inner {
      padding: 8px 10px;
      width: 103px;
      font-size: 14px;
    }
  }

  .el-button--small {
    padding: 8px 16px;
    box-shadow: none;
  }
  .el-checkbox {
    .el-checkbox__label {
      padding-left: 5px;
    }
    .is-focus {
      .el-checkbox__inner {
        border-color: #00b259;
      }
    }
  }

  //   重写table样式-小型
  .small_table {
    .el-table {
      th {
        padding: 6px 0;
        height: 36px;
      }
      th:first-child {
        padding-left: 10px;
      }
      .el-input {
        margin-bottom: 0;
        .el-input__inner {
          height: 24px;
          line-height: 24px;
        }
      }
      td {
        padding: 4px 0;
        height: 32px;
      }
      td:first-child {
        padding-left: 10px;
      }
    }
    .el-pagination {
      padding: 0;
      .el-pagination__total {
        height: 24px;
        line-height: 24px;
      }
      button {
        height: 24px;
        line-height: 24px;
        min-width: 24px;
      }
      .el-pager {
        .number {
          height: 24px;
          line-height: 24px;
          min-width: 24px;
        }
      }
      .pagination-jumper {
        height: 24px;
        line-height: 24px;
        input {
          width: 24px;
          height: 24px;
          line-height: 24px;
        }
      }
      .pagination-sizes {
        height: 24px;
        line-height: 24px;
        .pagination-select {
          height: 24px;
          .el-input {
            .el-input__inner {
              height: 24px;
            }
          }
        }
      }
    }
  }
}
</style>
